import { PropsWithChildren, ReactElement } from 'react';
import styles from './CardTable.module.scss';
import { VdsCard } from '@volt/volt-extended-components-react';
import { NoResults } from '@dmc/ui';
import classNames from 'classnames';

export interface CardTableProps {
  hasData: boolean;
  noDataDescription: string;
  header?: ReactElement;
}

export function CardTable({
  hasData,
  noDataDescription,
  children,
  header,
}: PropsWithChildren<CardTableProps>): ReactElement {
  return (
    <div className={styles.container}>
      <VdsCard className={styles.card} padding="spacing-05">
        <div
          className={classNames(styles.contents, {
            [styles['contents--withHeader']]: typeof header !== 'undefined',
          })}
        >
          {header}
          {hasData ? children : <NoResults description={noDataDescription} />}
        </div>
      </VdsCard>
    </div>
  );
}

export default CardTable;
